import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Reel } from "../GameComponents/Reel";
import { Symbol } from "../GameComponents/Symbol";
import { Settings } from "./Settings";
import { PlayList } from "../Components/Sounds/PlayList";

@engineComponent(ComponentTypes.DisplayObject)
export class ReelExtended extends Reel {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    protected respinStrip: Array<number>;

    private currentStrip: Array<number>;

    //******************************************************************************************************************
    //  INITIALIZE
    //******************************************************************************************************************

    public setRespinStrip(respinStrip: Array<number>): void {
        this.respinStrip = respinStrip;
    }

    //******************************************************************************************************************
    //  SHOW SYMBOLS
    //******************************************************************************************************************

    public showSymbols(useTransform: boolean = false): void {
        this.shouldBeStopping = false;
        this.isStopping = false;
        this.stoppingCounter = 0;
        this.isTeasing = false;
        this.teasingSymbols = [];

        this.currentStrip = this.strip;
        if (Settings.InRespin && this.respinStrip) {
            this.currentStrip = this.respinStrip;
        }

        this.x = this.positionX;
        this.y = this.positionY;

        if (!useTransform) {
            while (this.currentSymbols.length > 0) {
                this.returnSymbol(this.currentSymbols.pop());
            }
        }

        let bottomSymbols: Array<Symbol> = [];
        let topSymbols: Array<Symbol> = [];

        for (let i = 0; i < this.symbolBottomCount + this.symbolCount + this.symbolTopCount; i++) {
            let symbolId: number;
            let symbolCase: string;

            if (i < this.symbolBottomCount) {
                symbolId =
                    this.currentStrip[
                        (this.data.index +
                            this.symbolBottomCount +
                            this.symbolCount -
                            i -
                            1 +
                            this.currentStrip.length) %
                            this.currentStrip.length
                    ];
                symbolCase = Symbol.CaseBlur;
                if (i === this.symbolBottomCount - 1) {
                    if (Settings.isWild(symbolId)) {
                        symbolCase = Symbol.CaseRotation + "_NOTRAIL";
                    } else {
                        symbolCase = Symbol.CaseRotation;
                    }
                }
            } else if (i < this.symbolBottomCount + this.symbolCount) {
                symbolId = this.data.symbols[this.symbolBottomCount + this.symbolCount - i - 1];
                symbolCase = Symbol.CaseRotation;

                /*if(this.data.overlay != null) {
                    if(this.data.overlay[this.symbolBottomCount + this.symbolCount - i - 1] == Settings.SymbolMystery) {
                        symbolId = Settings.SymbolMystery;
                        this.currentSymbols[this.symbolBottomCount + this.symbolCount - i - 1] = this.getSymbol(symbolId - 1, symbolCase);
                    }
                }*/

                if (Settings.isWild(symbolId) && Settings.isRespin()) {
                    symbolCase = Symbol.CaseEmpty;

                    if (useTransform) {
                        this.currentSymbols[this.symbolBottomCount + this.symbolCount - i - 1] = this.getSymbol(
                            symbolId - 1,
                            symbolCase,
                        );
                    }
                }
            } else {
                symbolId =
                    this.currentStrip[
                        (this.data.index +
                            this.symbolBottomCount +
                            this.symbolCount -
                            i -
                            1 +
                            this.currentStrip.length) %
                            this.currentStrip.length
                    ];
                symbolCase = i === this.symbolBottomCount + this.symbolCount ? Symbol.CaseRotation : Symbol.CaseBlur;
            }

            if (!useTransform) {
                // when we don't want use symbols from WinAnimator
                this.currentSymbols.unshift(this.getSymbol(symbolId - 1, symbolCase));
            } else {
                // currentSymbols are used from WinAnimator. We only need to add new top and bottom symbols
                if (i < this.symbolBottomCount) {
                    bottomSymbols.unshift(this.getSymbol(symbolId - 1, symbolCase));
                } else if (i > this.symbolBottomCount + this.symbolCount - 1) {
                    topSymbols.unshift(this.getSymbol(symbolId - 1, symbolCase));
                }
            }
        }

        if (useTransform) {
            while (bottomSymbols.length > 0) {
                this.currentSymbols.push(bottomSymbols.shift());
            }

            while (topSymbols.length > 0) {
                this.currentSymbols.unshift(topSymbols.shift());
            }
        }

        for (let i = 0; i < this.currentSymbols.length; i++) {
            this.addChild(this.currentSymbols[i]);

            const symbol = this.currentSymbols[i];
            symbol.x = -symbol.offsetX;
            symbol.y = this.symbolHeight * (i - this.symbolTopCount) - symbol.offsetY;
        }
    }

    public spinStart(): void {
        this.shouldBeStopping = false;
        this.isStopping = false;
        this.stoppingCounter = 0;
        this.isTeasing = false;
        this.teasingSymbols = [];
        this.rollSpeed = this.speed;

        this.currentStrip = this.strip;
        if (Settings.InRespin && this.respinStrip) {
            this.currentStrip = this.respinStrip;
        }

        this.stripIndex = (this.data.index - this.symbolTopCount + this.currentStrip.length) % this.currentStrip.length;

        this.spinPreRoll();
    }

    protected updateReel(): void {
        this.returnSymbol(this.currentSymbols.pop());

        if (this.shouldBeStopping && !this.isStopping) {
            if (this.previousReel === null) {
                this.isStopping = true;
            } else if (this.previousReel.isStopping) {
                this.isStopping = true;
            }
        }

        this.stripIndex = (this.stripIndex - 1 + this.currentStrip.length) % this.currentStrip.length;

        let symbolId = this.currentStrip[this.stripIndex];
        let symbolCase = Symbol.CaseBlur;

        if (this.isStopping) {
            if (this.stoppingCounter < this.symbolBottomCount) {
                symbolId =
                    this.currentStrip[
                        (this.data.index +
                            this.symbolBottomCount +
                            this.symbolCount -
                            this.stoppingCounter -
                            1 +
                            this.currentStrip.length) %
                            this.currentStrip.length
                    ];
                symbolCase = Symbol.CaseBlur;
                if (this.stoppingCounter === this.symbolBottomCount - 1) {
                    if (Settings.isWild(symbolId)) {
                        symbolCase = Symbol.CaseRotation + "_TRAIL_OUT";
                    } else {
                        symbolCase = Symbol.CaseRotation;
                    }
                }
            } else if (this.stoppingCounter < this.symbolBottomCount + this.symbolCount) {
                symbolId = this.data.symbols[this.symbolBottomCount + this.symbolCount - this.stoppingCounter - 1];
                symbolCase = Symbol.CaseRotation;
            } else {
                symbolId =
                    this.currentStrip[
                        (this.data.index +
                            this.symbolBottomCount +
                            this.symbolCount -
                            this.stoppingCounter -
                            1 +
                            this.currentStrip.length) %
                            this.currentStrip.length
                    ];
                symbolCase =
                    this.stoppingCounter === this.symbolBottomCount + this.symbolCount
                        ? Symbol.CaseRotation
                        : Symbol.CaseBlur;
            }

            this.stoppingCounter++;
        }

        if (symbolId == Settings.SymbolBandit) {
            PlayList.play("SND_RespinWildReelRight");
        } else if (symbolId == Settings.SymbolSheriff) {
            PlayList.play("SND_RespinWildReelLeft");
        }

        this.currentSymbols.unshift(this.getSymbol(symbolId - 1, symbolCase));

        this.addChild(this.currentSymbols[0]);

        for (let i = 0; i < this.currentSymbols.length; i++) {
            const symbol = this.currentSymbols[i];
            symbol.x = -symbol.offsetX;
            symbol.y = this.symbolHeight * (i - this.symbolTopCount) - symbol.offsetY;
        }

        if (
            this.isStopping &&
            this.stoppingCounter === this.symbolBottomCount + this.symbolCount + this.symbolTopCount
        ) {
            this.spinPostRoll();
        } else {
            this.spinRoll();
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/ReelExtended.ts
 **/